import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { buildTeamPath } from 'utils/teamFromUrl';

/**
 * Returns the current team key from the URL params and a function to
 * build team-scoped paths.
 *
 * Usage:
 *   const { teamKey, teamPath } = useTeamPath();
 *   const href = teamPath('/assets'); // → "/t/ACME/assets" (or "/assets" if no team)
 */
export default function useTeamPath() {
  const { teamKey } = useParams<{ teamKey?: string }>();

  const teamPath = useCallback(
    (path: string) => (teamKey ? buildTeamPath(teamKey, path) : path),
    [teamKey],
  );

  return { teamKey: teamKey ?? null, teamPath };
}
